const FieldType = {
  GROUP: 'group',
  TEXT: 'text',
  TEXT_AREA: 'textarea',
  NUMBER: 'number',
  CURRENCY: 'currency',
  LIST: 'list',
  MULTI_LIST: 'multilist',
  OPTION: 'option',
  CALENDAR: 'calendar',
};

export default FieldType;
